export var setCaretPosition = function setCaretPosition(el, caretPos) {
  if (el.createTextRange) {
    var range = el.createTextRange();
    range.move('character', caretPos);
    range.select();
    return true;
  }
  if (el.selectionStart || el.selectionStart === 0) {
    el.focus();
    el.setSelectionRange(caretPos, caretPos);
    return true;
  }
  return false;
};
export var hasParentNode = function hasParentNode(child, parentClass) {
  var p = child;
  while (p) {
    var _p;
    if ((_p = p) !== null && _p !== void 0 && (_p = _p.className) !== null && _p !== void 0 && _p.includes && p.className.includes(parentClass)) {
      return true;
    }
    p = p.parentNode;
  }
  return false;
};
export function scrollToTop(scrollDuration) {
  var scrollStep = -global.window.scrollY / (scrollDuration / 15);
  var scrollInterval = setInterval(function () {
    if (global.window.scrollY !== 0) {
      global.window.scrollBy(0, scrollStep);
    } else {
      clearInterval(scrollInterval);
    }
  }, 15);
}
export function scrollTo(element, duration) {
  var extraSpaceElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!global.window) return false;
  var extraHeight = 0;
  var startingY = global.window.pageYOffset;
  var elementY = global.window.pageYOffset + global.document.querySelector(element).getBoundingClientRect().top;
  extraSpaceElements.forEach(function (e) {
    extraHeight += global.document.querySelector(e) && global.document.querySelector(e).offsetHeight;
  });
  var diff = elementY - startingY - extraHeight;
  var start;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  global.window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);
    global.window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      global.window.requestAnimationFrame(step);
    }
  });
  return false;
}